import { collection, doc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../config';
import { handleFirebaseError } from '../../error-handling';
import type { Organization } from '@/types/organization';

export async function createOrganization(data: Partial<Organization>): Promise<string | null> {
  try {
    const organizationsRef = collection(db, 'organizations');
    const newOrgRef = doc(organizationsRef);
    
    await setDoc(newOrgRef, {
      ...data,
      id: newOrgRef.id,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now()
    });

    return newOrgRef.id;
  } catch (error) {
    handleFirebaseError(error, 'Error creating organization');
    return null;
  }
}